import { SagaWithReturnType } from "@multiweb/types/react";

export const DEFAULT_DATASOURCE_KEY = "default";

/**
 * Interface pro customizaci datasource
 */
export interface ICoreDataSourceRegistrator {
    /**
     * Registrace metody do datasource
     * @param methodName Název metody
     * @param methodBody Tělo metody
     * @param dataSourceId Identifikátor datasource
     */
    registerMethodToDataSource(methodName: string, methodBody: SagaWithReturnType<any, any>, dataSourceId?: string): void;

    /**
     * Vráti metodu
     * @param methodName Název metody
     * @param dataSourceId Identifikátor datasource
     * @param useDefaultIfNotExist Pokud neexistuje vrátít default
     */
    getMethodByDataSource(methodName: string, dataSourceId?: string, useDefaultIfNotExist?: boolean): SagaWithReturnType<any, any> | undefined;
}
